import React from 'react';
import Markdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import Typewriter from 'typewriter-effect';
import DOMPurify from 'dompurify';

interface TextMessageProps {
  message: string;
  isBot: boolean; // Tracking the message sender
  animate: boolean;
  hasContent: boolean;
  onTypingStatusChange: (status: boolean) => any;
}

const TextMessage: React.FC<TextMessageProps> = ({
  message,
  animate,
  onTypingStatusChange,
  hasContent,
  isBot,
}) => {
  // Defensive sanitization layer for XSS protection
  const sanitizedMessage = DOMPurify.sanitize(message || '');

  if (animate) {
    return (
      <Typewriter
        options={{ cursor: '', delay: 5 }}
        onInit={(typewriter) => {
          typewriter
            .typeString(sanitizedMessage)
            .callFunction(() => {
              onTypingStatusChange(false);
            })
            .start();
        }}
      />
    );
  }

  // 💡 VAPT FIX: Conditional routing for HTML parsing
  return isBot ? (
    // 1. Bot Response: Keep rehypeRaw active so legitimate CMS layout tags (<p>, <ul>, <strong>) render beautifully
    <Markdown className="markdown-content" rehypePlugins={[rehypeRaw]}>
      {hasContent ? sanitizedMessage : 'Please try different question'}
    </Markdown>
  ) : (
    // 2. User Input: Remove rehypeRaw completely. 
    // If they typed `<h1 style="color: red">Test</h1>`, it renders safely as literal text on screen.
    <Markdown className="markdown-content">
      {hasContent ? message : 'Please try different question'}
    </Markdown>
  );
};

export default TextMessage;